import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { Sidemenu } from './Sidemenu';

export const sidemenuBridge = react2angular(Sidemenu, ['isMobile']);
